import { AnalyticsActionSchema, AnalyticsConst, AnalyticsUserPropertiesSchema } from "../actions/analyticsActions";

export interface AnalyticsState {
  resetVersion: number;
  resetId: number;
  userProperties: AnalyticsUserPropertiesSchema | null;
}

const initialState: AnalyticsState = {
  resetVersion: 0,
  resetId: 0,
  userProperties: null
};

const analyticsReducer = (state = initialState, action: AnalyticsActionSchema): AnalyticsState => {
  switch (action.type) {
    case AnalyticsConst.SET_USER_PROPERTIES:
      return {
        ...state,
        userProperties: action.payload as AnalyticsUserPropertiesSchema
      };
    case AnalyticsConst.RESET:
      return {
        ...state,
        resetVersion: state.resetVersion + 1,
        resetId: Number(action.payload?.id || state.resetId + 1)
      };
    default:
      return state;
  }
};

export default analyticsReducer;
